module.exports = __webpack_public_path__ + "img/d02.d962bcdb.png";